import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5a3d8ddc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["for"];
var _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("label", {
    "for": _ctx.$attrs["for"],
    "class": _normalizeClass(["tw-absolute tw-left-15px tw-h-5", [_ctx.labelState, {
      'tw-text-w-secondary': _ctx.disabled
    }, _ctx.$attrs['label-classes']]]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.$emit('click');
    }, ["stop"]))
  }, [_createElementVNode("span", {
    "class": _normalizeClass(["tw-font-medium tw-text tw-text-w-black", {
      '!tw-text-w-secondary': _ctx.disabled
    }]),
    innerHTML: _ctx.labelText
  }, null, 10 /* CLASS, PROPS */, _hoisted_2), _ctx.$attrs.required ? (_openBlock(), _createElementBlock("sup", {
    key: 0,
    "class": _normalizeClass(["tw-text tw-text-w-primary -tw-top-[0.3rem]", {
      'tw-text-w-secondary': _ctx.disabled
    }])
  }, " *", 2 /* CLASS */)) : _createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
}